import DiseaseItem from './DiseaseItem'

export default DiseaseItem
